import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { ReactComponent as IconPlane } from 'media/svg/plane.svg';

import { FlightDistance } from 'types/Search/form';

import {
    getDistanceLabel,
    getDistanceWordingLabel,
} from '../../__helper/getTargetDistanceLabel';
import styles from '../../Destination.module.scss';
import { TargetDistance } from '../../types';

export const flightDistances: TargetDistance[] = [
    {
        name: 'short',
        lvl: 2,
        type: 'distance',
        value: FlightDistance.Short,
        expand: 'N',
    },
    {
        name: 'middle',
        lvl: 2,
        type: 'distance',
        value: FlightDistance.Middle,
        expand: 'N',
    },
    {
        name: 'long',
        lvl: 2,
        type: 'distance',
        value: FlightDistance.Long,
        expand: 'N',
    },
];

interface TargetDistanceListProps {
    onClick?: (entry: TargetDistance) => void;
}

const TargetDistanceList = ({ onClick }: TargetDistanceListProps) => {
    const { t } = useTranslation();

    return (
        <>
            <hr className={styles.Line} />
            <div className={styles.Header}>
                {t('TRANS-destination-by-distance')}
            </div>
            <ul
                className={classNames(
                    styles.ResultList,
                    styles.FlightDistanceList
                )}
            >
                {flightDistances?.map((entry) => (
                    <li
                        className={styles.ListItem}
                        key={entry.name}
                        onClick={() => {
                            onClick?.(entry);
                        }}
                    >
                        <div className={styles.ListItemContent}>
                            <div className={styles.Icon}>
                                <IconPlane />
                            </div>
                            <em>{getDistanceWordingLabel(entry.value, t)}</em>
                            <span>{getDistanceLabel(entry.value, t)}</span>
                        </div>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default TargetDistanceList;
